import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Page } from '../page.config';
import { PageActions } from '../store/page.feature';

/*
This is a utility service for convenient programmatical navigation between
pages.  It is not very useful at the moment.  In the future methods for
individual pages may be added with properly typed parameters.
*/
@Injectable({
  providedIn: 'root',
})
export class PageService {
  private store = inject(Store);

  goToPage(pageName: Page) {
    this.store.dispatch(PageActions.goToPage({ page: pageName }));
  }
}
